import {IndexedSearch} from '../../../services/indexDB/indexeddbServiceSearches';

export enum SuggestionType {
    Homepage = 'HOMEPAGE',
    Subforms = 'SUBFORMS',
    Actions = 'ACTIONS',
    Searches = 'SEARCHES'
}

export type SnoozedSuggestion = {
    type: SuggestionType;
    reference: string;
    lang?: number;
    search?: IndexedSearch;
};

export interface CenterData {
    userName: string;
    company: string;
    data?: SnoozedSuggestion[];
}
